module.exports = __webpack_public_path__ + "img/mile3-m@2.b6ef79c3.jpg";